import { isExpired } from "react-jwt";
import { postRequest, getRequest } from '../utils/axios';
// import axios from 'axios';


export const authService = {
    login,
    logout,
    register,
    fetchUser,
    setDebugMode,
    tokenNeedsRefresh,
    refreshToken,
};

function login(username, password, onSuccess, onError) {
  return postRequest(
    '/api/token/',
    {'username': username, 'password': password},
    (response) => {
      const accessToken = response.data.access;
      const refreshToken = response.data.refresh;

      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);

      // fetch user config (moved to Login.jsx)
      // fetchUser()

      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function register(data, onSuccess, onError) {
  return postRequest(
    '/api/v1/register/',
    data,
    (response) => {
      const accessToken = response.data.access;
      const refreshToken = response.data.refresh;

      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);

      // fetch user config (moved to Register.jsx)
      // fetchUser()

      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function tokenNeedsRefresh(token) {
  return isExpired(token);
}

function refreshToken(onSuccess, onError) {
  localStorage.setItem('refreshingToken', true);
  return postRequest(
    '/api/token/refresh/',
    {'refresh': localStorage.getItem('refreshToken')},
    (response) => {
      const accessToken = response.data.access;
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshingToken', false);
      console.log("got a new token")
      if (onSuccess){
        return onSuccess(accessToken)
      }
    },
    (error, response) => {
      // log the user out if their refresh failed
      localStorage.setItem('refreshingToken', false);
      authService.logout()
      if (onError){
        console.log("returning onError")
        return onError(error, response)
      }
    }
  )
}


function fetchUser(onSuccess, onError) {
  return getRequest(
    '/api/v1/user-config/',
    (response) => {
      const existingUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
      const persistedDebugMode = Boolean(existingUser?.features?.debug_mode);
      const debugModeAvailable = Boolean(response?.data?.features?.debug_mode_available);
      const mergedUser = {
        ...response.data,
        features: {
          ...(response.data?.features || {}),
          debug_mode: debugModeAvailable ? persistedDebugMode : false,
        },
      };
      localStorage.setItem('currentUser', JSON.stringify(mergedUser));
      if (onSuccess){
        onSuccess(response)
      }

      // identify user in analytics
      // identifyUser(response.data)
    },
    (error, response) => {
      if (onError){
        onError(error, response)
      }
    }
  )
}

function setDebugMode(enabled) {
  const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
  const debugModeAvailable = Boolean(currentUser?.features?.debug_mode_available);
  const nextUser = {
    ...currentUser,
    features: {
      ...(currentUser?.features || {}),
      debug_mode: debugModeAvailable ? Boolean(enabled) : false,
    },
  };
  localStorage.setItem('currentUser', JSON.stringify(nextUser));
}


function logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('refreshingToken');
    window.location = '/login/'
}